import { Box, Unstable_Grid2 as Grid } from "@mui/material";
import { Question, Type1Question, Type2Question } from "../../models/Question";
import { Type1QuestionChart } from "./Type1QuestionChart";
import { Type2QuestionChart } from "./Type2QuestionChart";

interface Props {
  questions: Question[];
  type: "type1" | "type2";
  startIndex?: number;
  templateId?: number;
}

export function ChartsBlock({
  questions,
  type,
  startIndex = 1,
  templateId,
}: Props): JSX.Element {
  if (type === "type1" || type === 'type2') {
    return (
      <>
        {type === 'type1' && questions.map((question, index) => {
          // Para ENPS, la primera pregunta ocupa toda la línea
          const isENPSFirstQuestion = templateId === 4 && (startIndex + index) === 1;
          const colClass = isENPSFirstQuestion ? "col-md-12 my-2" : "col-md-6 my-2";
          
          return (
            <Box key={question.id} className={colClass}>
              {
              <Type1QuestionChart
                question={question as Type1Question}
                index={startIndex + index}
                templateId={templateId}
              />
            }
            </Box>
          );
        })}

        {type === 'type2' && questions.map((question, index) => (
            <Box key={question.id} className="col-md-12 my-2">
              {
                <Type2QuestionChart
                    question={question as Type2Question}
                    index={startIndex + index}
                />
              }
            </Box>
        ))}
      </>
    );
  }

  return <></>;
}
